/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Identity_VerificationInputs */

const en_sovereign_identity_verification = /** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identity & title verification`)
};

const id_sovereign_identity_verification = /** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi identitas & hak milik`)
};

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const es_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const fr_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const de_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const ja_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const zh_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const ar_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const it_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const ru_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const pt_sovereign_identity_verification = en_sovereign_identity_verification;

/** @type {(inputs: Sovereign_Identity_VerificationInputs) => LocalizedString} */
const ko_sovereign_identity_verification = en_sovereign_identity_verification;

/**
* | output |
* | --- |
* | "Identity & title verification" |
*
* @param {Sovereign_Identity_VerificationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_identity_verification = /** @type {((inputs?: Sovereign_Identity_VerificationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Identity_VerificationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_identity_verification(inputs)
	if (locale === "es") return es_sovereign_identity_verification(inputs)
	if (locale === "fr") return fr_sovereign_identity_verification(inputs)
	if (locale === "de") return de_sovereign_identity_verification(inputs)
	if (locale === "ja") return ja_sovereign_identity_verification(inputs)
	if (locale === "zh") return zh_sovereign_identity_verification(inputs)
	if (locale === "ar") return ar_sovereign_identity_verification(inputs)
	if (locale === "id") return id_sovereign_identity_verification(inputs)
	if (locale === "it") return it_sovereign_identity_verification(inputs)
	if (locale === "ru") return ru_sovereign_identity_verification(inputs)
	if (locale === "pt") return pt_sovereign_identity_verification(inputs)
	return ko_sovereign_identity_verification(inputs)
});